import { z } from 'zod';

const GeoJsonProperties = z.object({
  radius: z.number().optional(),
});

const Geometry = z.object({
  type: z.string(),
  coordinates: z.array(z.any()),
});

export const shapeSchema = z.object({
  properties: GeoJsonProperties,
  geometry: Geometry,
});
